import QRCode from "qrcode";
import { useEffect, useState } from "react";
import { rpc } from "../../services/datos";
import Modal from "../../shared/components/Modal";
import { botonPequeno, botonPrimario, fechaLarga, nombreReunion } from "../../shared/estilos";

// QR de la entrada para que cada persona registre su asistencia desde el celular.
// Se puede proyectar en pantalla o imprimir; solo funciona el día de la reunión.
function QrRegistro({ servicio, onCerrar }) {
  const [enlace, setEnlace] = useState(null);
  const [imagen, setImagen] = useState("");
  const [error, setError] = useState("");
  const [copiado, setCopiado] = useState(false);

  useEffect(() => {
    rpc("registro_qr", { p_servicio: servicio.id })
      .then(async (datos) => {
        const url = `${window.location.origin}/registro/${servicio.id}/${datos.codigo}`;
        setEnlace({ ...datos, url });
        setImagen(await QRCode.toDataURL(url, { width: 640, margin: 2, color: { dark: "#000000", light: "#ffffff" } }));
      })
      .catch((e) => setError(e.message || "No se pudo generar el QR"));
  }, [servicio.id]);

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(enlace.url);
      setCopiado(true);
    } catch {
      setCopiado(false);
    }
  };

  const imprimir = () => {
    const ventana = window.open("", "_blank", "width=800,height=900");
    if (!ventana) return;
    ventana.document.write(`<!doctype html><title>QR de asistencia</title>
      <body style="font-family:Montserrat,Arial,sans-serif;text-align:center;padding:40px">
      <h1 style="font-weight:900;text-transform:uppercase;letter-spacing:-1px;margin:0">Mi Casa</h1>
      <p style="letter-spacing:6px;text-transform:uppercase;font-size:12px">La familia que buscabas</p>
      <h2 style="text-transform:uppercase">Registra tu asistencia</h2>
      <p>${nombreReunion(servicio)} · ${fechaLarga(servicio.fecha)}</p>
      <img src="${imagen}" style="width:420px;height:420px" alt="QR" />
      <p>Escanea con la cámara de tu celular</p></body>`);
    ventana.document.close();
    ventana.focus();
    ventana.print();
  };

  return (
    <Modal titulo="QR de asistencia" onCerrar={onCerrar} ancho="max-w-lg">
      <p className="text-sm text-gray-400">
        {nombreReunion(servicio)} · <span className="capitalize">{fechaLarga(servicio.fecha)}</span>
      </p>
      {error && <p role="alert" className="mt-4 text-sm text-red-300">{error}</p>}
      {!error && !imagen && <p className="mt-6 animate-pulse text-gray-400">Generando QR...</p>}
      {imagen && (
        <>
          <img src={imagen} alt="Código QR para registrar la asistencia" className="mx-auto mt-5 w-full max-w-xs rounded-xl bg-white p-2" />
          {!enlace.abierto && (
            <p className="mt-4 rounded border border-yellow-900 bg-yellow-950/30 p-3 text-sm text-yellow-200">
              Este QR solo registra asistencia el día de la reunión ({fechaLarga(enlace.fecha, { day: "numeric", month: "long" })}).
            </p>
          )}
          <p className="mt-4 text-sm text-gray-400">
            Proyéctalo en la pantalla o imprímelo para la entrada. Cada persona lo escanea con la cámara de su celular;
            la primera vez escribe su correo y después solo toca “¡Estoy aquí!”.
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            <button onClick={imprimir} className={botonPrimario}>Imprimir</button>
            <button onClick={copiar} className={botonPequeno}>{copiado ? "Enlace copiado" : "Copiar enlace"}</button>
          </div>
        </>
      )}
    </Modal>
  );
}

export default QrRegistro;
